<template>
    <div class="content">
        <div class="content-select">
            <el-row :gutter="20">
                <el-col :span="8">
                    <div class="select-title">
                        <div class="title-img">
                            <img src="@/assets/appraisal/select-icon.png" alt="">
                        </div>
                        <div class="title-info">
                            <span>{{ title }}</span>
                        </div>
                    </div>
                </el-col>
                <el-col :span="2" :offset="14">
                    <div class="select-serch">
                       <el-button icon="el-icon-arrow-left" type="primary" size="small" @click="handleBack">返回</el-button>
                    </div>
                </el-col>
            </el-row>
        </div>
       <div class="content-header">
        <div class="toolbar-container">
            <div class="toolbar-text">
                <span>{{ title }}</span>
            </div>
            <div class="title-hint" v-if="institutionInfo">
                <div class="title-hint-item">
                    <div class="item-icon"><img src="@/assets/images/training/incentive-icon.png" alt=""></div>
                    <div class="item-text">统一社会信用代码: {{ institutionInfo.institutionId || '-' }}</div>
                </div>
                <div class="title-hint-item">
                    <div class="item-icon"><img src="@/assets/images/training/name-icon.png" alt=""></div>
                    <div class="item-text">联系人: {{ institutionInfo.contactPerson || '-' }}</div>
                </div>
                <div class="title-hint-item">
                    <div class="item-icon"><img src="@/assets/images/training/phone-icon.png" alt=""></div>
                    <div class="item-text">电话: {{ institutionInfo.contactPhone || '-' }}</div>
                </div>
                <div class="title-hint-item">
                    <div class="item-icon"><img src="@/assets/images/training/address-icon.png" alt=""></div>
                    <div class="item-text">位置: {{ institutionInfo.districtName || institutionInfo.address || '-' }}</div>
                </div>
            </div>
        </div>
        <myTableSearch 
        :isOperate="true" 
        :operateWidth="376" 
        :formData="formData" 
        :tableLabel="tableLabel"
		:queryFn="queryFn" 
        :queryParams="queryParams"
         @successQuery="successQuery" 
         :searchColLg="6" 
         :isPagination="false"
         ref="tableRef">
			<template slot="projectLevel" slot-scope="{ row }">
				<el-tag 
					:style="getLevelTagStyle(row.projectLevel)"
					size="small"
					effect="plain"
				>
					{{ row.projectLevel || '-' }}
				</el-tag>
			</template>
			<template slot="operate" slot-scope="scope">
					<el-button type="text" @click="handleView(scope.row)">详情</el-button>
                    <el-button type="text" @click="handleTeam(scope.row)">计划</el-button>
                    <el-button type="text" @click="handleTeachingPoint(scope.row)">学员</el-button>
                    <el-button type="text" @click="handleTeacher(scope.row)">老师</el-button>
                    <el-button type="text" @click="handleTrainingProgram(scope.row)">签到</el-button>
				</template>
			</myTableSearch>.
       </div>
       <ClassDetail ref="classDetailRef"  :isDialog="isDetailDialog" :title="detailTitle"  :classId="classId" />
       <TeachingPlan ref="teachingPlanRef"  :isDialog="isPlanDialog" :title="planTitle"  :classId="classId" />
       <Student ref="studentRef"  :isDialog="isStudentDialog" :title="studentTitle"  :classId="classId" />
       <Teacher ref="teacherRef"  :isDialog="isTeacherDialog" :title="teacherTitle"  :classId="classId" />
       <SignIn ref="signInRef"  :isDialog="isSignInDialog" :title="signInTitle"  :classId="classId" />
    </div>
</template>

<script>
import '@/assets/css/base.css'
import {getTrainingType, getTrainingLevel, getTrainingClassListInfo, getTrainingInstitutionDetail} from '@/api/training'
import ClassDetail from '../components/classDetail.vue';
import TeachingPlan from '../components/teachingPlan.vue';
import Student from '../components/student.vue';
import Teacher from '../components/teacher.vue';
import SignIn from '../components/signIn.vue';



export default {
    name: 'TrainingClass',
    components: {
        ClassDetail,
        TeachingPlan,
        Student,
        Teacher,
        SignIn
	},
    data() {
        return {
			isDetailDialog: false,
			isPlanDialog: false,
			isStudentDialog: false,
			isTeacherDialog: false,
			isSignInDialog: false,
            title: '', // 页面标题（从路由获取）
            detailTitle: '', // 详情弹窗标题
            planTitle: '', // 计划弹窗标题
            studentTitle: '', // 学员弹窗标题
            teacherTitle: '', // 老师弹窗标题   
            signInTitle: '', // 签到弹窗标题
            institutionId: '',
            classId: '',
            institutionInfo: {},
			queryParams: {

			},
			formData: [
                {
                    label:'培训类型',
                    type: 'select',
                    key: 'subsidyType',
                    colLg: 6,
                    data: []
                },
                {
                    label:'培训等级',
                    type: 'select',
                    key:'projectLevel',
                    colLg: 6,
                    data: []
                },
                {
                    label:'班级名称',
                    type: 'input',
                    key: 'className',
                    colLg: 6,
                    placeholder: '请输入班级名称'
                },
			],
			tableLabel: [
                {
                    prop:'classId',
                    label: '班级编号',
                    minWidth: 150
                },
				{
                    prop: 'className',
                    label: '班级名称',
                    minWidth: 150
                },
                {
                    prop: 'projectName',
                    label: '培训项目',
                    minWidth: 150
                },
                {
                    prop: 'projectLevel',
                    label: '培训等级',
                    minWidth: 150
                },
                {
                    prop: 'subsidyType',
                    label: '培训类型',
                    minWidth: 150
                },
                {
                    prop: 'studentCount',
                    label: '学生人数',
                    minWidth: 150
                }
			],
		}
    },
    created() {
        this.initData()
    },
    watch: {
        // 监听路由变化，确保参数更新
        '$route'(to, from) {
            if (to.query.institutionId !== from.query.institutionId) {
                this.initData()
            }
        }
    },
    methods: {
        // 初始化数据
        async initData() {
            // 从路由参数获取统一社会信用代码和标题
            const routeInstitutionId = this.$route.query.institutionId
            const routeTitle = this.$route.query.title
            
            console.log('路由参数:', { routeInstitutionId, routeTitle })
            
            if (routeInstitutionId) {
                this.institutionId = routeInstitutionId
                console.log('设置institutionId:', this.institutionId)
                const res = await getTrainingInstitutionDetail({ institutionId: this.institutionId })
                if (res && res.code === 200 && res.data) {
                    this.institutionInfo = res.data
                }
            }
            if (routeTitle) {
                this.title = routeTitle
            }
            
            // 加载下拉选项数据
            if (this.institutionId) {
                this.loadTrainingTypeData()
                this.loadTrainingLevelData()
            } else {
                console.warn('institutionId为空，无法加载下拉选项数据')
            }
        },
        //返回上一页
        handleBack() {
            this.$router.go(-1)
        },
		// 获取列表数据
		queryFn(queryParams) {
            // 确保institutionId有值
            if (!this.institutionId) {
                // 如果为空，再次尝试从路由获取
                if (this.$route.query.institutionId) {
                    this.institutionId = this.$route.query.institutionId
                }
            }
            
            console.log('查询参数 - institutionId:', this.institutionId)
            console.log('查询参数 - queryParams:', queryParams)
            
            // 从 queryParams.query 中提取查询条件（myTableSearch 组件会将表单数据放在 query 中）
            const query = queryParams.query || {}
            
            // 合并统一社会信用代码和查询条件到查询参数
            const params = {
                ...query,
                institutionId: this.institutionId,
            }
            
            console.log('最终查询参数:', params)
			return getTrainingClassListInfo(params).then(res => {
                // 处理响应数据格式，不需要分页，直接返回数组
                if (res && res.code === 200 && res.data) {
                    // 如果data是数组，直接返回
                    if (Array.isArray(res.data)) {
                        return {
                            ...res,
                            data: res.data
                        }
                    }
                    // 如果data是对象且有rows属性，返回rows数组
                    if (res.data && typeof res.data === 'object' && !Array.isArray(res.data) && res.data.rows) {
                        return {
                            ...res,
                            data: res.data.rows
                        }
                    }
                }
                return res
            })
		},
		// 获取培训类型数据
		async loadTrainingTypeData() {
			try {
                const params = this.institutionId ? { institutionId: this.institutionId } : {}
                console.log('加载培训类型，参数:', params)
                const res = await getTrainingType(params)
                if (res && res.code === 200 && res.data) {
                    this.updateFormDataWithSelect('subsidyType', res.data)
                }
            } catch (error) {
                console.error('加载培训类型失败:', error)
            }
		},
		// 获取培训等级数据
		async loadTrainingLevelData() {
			try {
                const params = this.institutionId ? { institutionId: this.institutionId } : {}
                console.log('加载培训等级，参数:', params)
                const res = await getTrainingLevel(params)
                if (res && res.code === 200 && res.data) {
                    this.updateFormDataWithSelect('projectLevel', res.data)
                }
            } catch (error) {
                console.error('加载培训等级失败:', error)
            }
		},
		// 更新下拉选项
		updateFormDataWithSelect(key, data) {
			if (!data) return

			const index = this.formData.findIndex(item => item.key === key)
			if (index !== -1) {
				// 判断数据格式：如果是字符串数组，转换为对象数组
				let formattedData = []
				if (Array.isArray(data)) {
					// 检查第一个元素是否是字符串
					if (data.length > 0 && typeof data[0] === 'string') {
						// 字符串数组格式：["社会化学员培训", "新型学徒制培训", ...]
						formattedData = data.map(item => ({
							label: item,
							value: item,
							dictLabel: item,
							dictValue: item
						}))
					} else {
						// 对象数组格式
						formattedData = data.map(item => ({
							label: item.label || item.name || item.dictLabel || item.value || item,
							value: item.value || item.dictValue || item.code || item,
							dictLabel: item.dictLabel || item.label || item.name || item.value || item,
							dictValue: item.dictValue || item.value || item.code || item
						}))
					}
				}
				
				// 在数据开头添加"全部"选项
				const dataWithAll = [
					{
						label: '全部',
						value: '',
						dictLabel: '全部',
						dictValue: ''
					},
					...formattedData
				]
				this.$set(this.formData[index], 'data', dataWithAll)
			}
		},
		// 更新总数
		successQuery(e) {
			// 可以在这里处理总数或其他回调数据
			if (e && e.total !== undefined) {
				// 处理总数
			}
		},
		// 查看详情
		handleView(row) {
			console.log('查看详情', row)
			this.isDetailDialog = true
            this.detailTitle = `${row.className}-班级信息`
            this.classId = row.classId
			this.$refs.classDetailRef.openDialog(row)

		},
		// 计划
		handleTeam(row) {
			console.log('查看计划', row)
			this.isPlanDialog = true
            this.planTitle = `${row.className}-培训班授课计划`
            this.classId = row.classId
			this.$refs.teachingPlanRef.openDialog(row)
		},
		// 学员
		handleTeachingPoint(row) {
			console.log('查看学员/老师', row)
			this.isStudentDialog = true
            this.studentTitle = `${row.className}-班级学员`
            this.classId = row.classId
			this.$refs.studentRef.openDialog(row)
		},
        // 老师
        handleTeacher(row) {
            console.log('查看老师', row)
            this.isTeacherDialog = true
            this.teacherTitle = `${row.className}-班级老师`
            this.classId = row.classId
            this.$refs.teacherRef.openDialog(row)
        },
		// 签到
		handleTrainingProgram(row) {
			console.log('查看签到', row)
			this.isSignInDialog = true
            this.signInTitle = `${row.className}-班级签到`
            this.classId = row.classId
            this.$refs.signInRef.openDialog(row)
		},
		// 获取等级标签样式
		getLevelTagStyle(levelName) {
			if (!levelName) {
				return {
					backgroundColor: '#1A0263B7',
					color: '#0263B7',
					border: 'none'
				}
			}
			
			const level = String(levelName)
			
			if (level.includes('高级')) {
				return {
					backgroundColor: 'rgba(255, 200, 81, 0.1)',
					color: '#FFC851',
					border: 'none'
				}
			} else if (level.includes('中级')) {
				return {
					backgroundColor:'rgba(0, 201, 253, 0.1)' ,
					color: '#00C9FD',
					border: 'none'
				}
			} else if (level.includes('初级')) {
				return {
					backgroundColor: 'rgba(32, 201, 128, 0.1)',
					color: '#00C9FD',
					border: 'none'
				}
			} else {
				return {
					backgroundColor: 'rgba(2, 99, 183, 0.1)',
					color: '#0263B7',
					border: 'none'
				}
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.content {
    width: 100%;
    height: auto;
    background: #fff;
    display: flex;
    flex-direction: column;
    padding-bottom: 24px;

    &-select{
        height: 50px;
        background: rgba(41, 125, 238, 0.1);
        .select-title{
            height: 46px;
            display: flex;
            align-items: center;
            gap: 12px;
            padding-left: 16px;
            .title-img{
                width: 18px;
                height: 18px;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            .title-info{
                color: var(--vt-c-black-mute-soft);
                font-size: 16px;
                font-weight: 700;
            }
        }
        .select-serch{
            margin-top: 12px;
            display: flex;
            align-items: center;
            gap: 8px;
            .serch-hint{
                color: var(--vt-c-black-mute-soft);
                font-size: 14px;
                font-weight: 400;
            }
            .serch-info{
                height: 28px;
                display: flex;
                align-items: center;
                gap: 12px;
                .info-item{
                    width: 120px;
                    height: 28px;
                    text-align: center;
                    line-height: 28px;
                    background: var(--vt-c-blue-mute);
                    color: var(--vt-c-blue);
                    border-radius: 2px;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    
                    &:hover {
                        opacity: 0.8;
                    }
                    
                    &.active {
                        background: var(--vt-c-blue);
                        color: var(--vt-c-white);
                    }
                    
                    &:active:not(.active) {
                        transform: scale(0.98);
                    }
                }
            }
        }
    }
    &-header{
        margin-top: 16px;
        padding: 0 24px;
        
        /deep/.myTableSearch {
            padding: 0;
        }
    }
}

.link-text {
    color: #409eff;
    text-decoration: none;
    cursor: pointer;
    
    &:hover {
        text-decoration: underline;
    }
}

.toolbar-container {
    width: 100%;
    height: 112px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 24px;
    background: url('~@/assets/images/training/classTitleBg.png') no-repeat;
    background-size: 100% 100%;
    margin-bottom: 16px;
    .toolbar-text{
        font-size: 20px;
        font-weight: 700;
        color: var(--vt-c-blue);
        margin-bottom: 16px;
    }
    .title-hint{
        display: flex;
        align-items: center;
        gap: 120px;
        .title-hint-item{
            display: flex;
            align-items: center;
            gap: 12px;
            .item-icon{
                width: 18px;
                height: 18px;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            .item-text{
                font-size: 14px;
                font-weight: 400;
                color: var(--vt-c-black-soft);
            }
        }
    }
   
}
</style>